export default "__VITE_ASSET__BKarNhIe__"